import logger from '@utils/logger'

export async function getLifeDetailsCompDynamically(LifeInputOpen, setLifeDynamicWidget, isFloatingWidget) {
  if (LifeInputOpen || isFloatingWidget) {
    try {
      // Dynamically import the module
      const dynamicImports = await import('@acko-tech/acko-calculators.ui.sem-input')

      // Ensure the Overlay component is correctly exported from the module
      if (dynamicImports?.SemInputOverlay) {
        // Set the Overlay component in the state or wherever you need it
        setLifeDynamicWidget({
          Overlay: dynamicImports?.SemInputOverlay,
        })
      } else {
        // Handle the case where Overlay is not available
        logger.error('Overlay component not found in dynamic import.')
      }
    } catch (error) {
      // Handle any errors that may occur during dynamic import
      logger.error('Error while dynamically importing the module:', error)
    }
  }
}
